import Service from './abstract';
import usersService from './users';
import _ from 'lodash';
import { transfersService } from '.';

const withPersonAddress = 'person.addresses,person.addresses.state,person.addresses.country,person.addresses.city,person.addresses.type';
const defaultWith = 'childs,payments,currency,currency.attributes,currency.attributes.attribute,type,accounts,accountOrigin,accountOrigin.wallet,accountOrigin.currency,accountOrigin.currency.attributes,accountOrigin.currency.attributes.attribute,accountDestination,accountDestination.wallet,accountDestination.currency,accountDestination.currency.attributes,accountDestination.currency.attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: `${defaultWith},${withPersonAddress}`,
    withUsers: 'person,person.attributes,person.attributes.attribute,person.documents,person.documents.type'
};
const withAccount = 'user.accounts,user.accounts.account,user.accounts.account.attributes,user.accounts.account.attributes.attribute,user.accounts.account.wallet,user.accounts.account.currency,user.accounts.account.currency.attributes,user.accounts.account.currency.attributes.attribute,user.accounts.account.product,user.accounts.account.product.attributes,user.accounts.account.product.attributes.attribute,user.accounts.account.product.type';
const defaultSupplier = 'user,user.person,user.person.attributes,user.person.attributes.attribute,user.person.documents,user.person.documents.type,user.person.emails,user.person.telephones,user.person.telephones.type,user.person.addresses,user.person.fiscal_iva_condition,user.person.fiscal_iibb_condition,user.accounts';
const defaultOptionsGetById = {
    with: `${defaultSupplier},${withAccount}`
};
const defaultCalculate = {
    with: 'payments'
};

const defaultFiles = {
    order: 'created_at-DESC',
    tiny: false,
    pageSize: 20
};

class Suppliers extends Service {
    constructor () {
        super('suppliers');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    get defaultOptionsGetById () {
        return _.merge({}, super.defaultOptionsGetById, defaultOptionsGetById);
    }

    getTransfers (options = {}) {
        return this.get({
            url: `${this.basePath}/suppliers/transfers`,
            qs: _.defaultsDeep({}, options, defaultOptionsFind)
        })
            .then(transfers => this.normalizeAllTransfers(transfers));
    }

    getTransfersTotals (options = {}) {
        return this.get({
            url: `${this.basePath}/suppliers/transfers`,
            qs: options
        });
    }

    calculatePayments (options = {}) {
        return this.get({
            url: `${this.basePath}/suppliers/payments/calculate`,
            qs: _.defaultsDeep({}, options, defaultCalculate)
        });
    }

    createPayment (data = {}) {
        return this.post({
            url: `${this.basePath}/suppliers/payments`,
            data
        });
    }

    deletePayment (id) {
        return this.delete({
            url: `${this.basePath}/suppliers/payments/${id}`
        });
    }

    uploadFile (data, id) {
        return this.post({
            url: `${this.basePath}/suppliers/${id}/files`,
            json: false,
            data
        });
    }

    filesList (id) {
        return this.get({
            url: `${this.basePath}/suppliers/${id}/files`,
            qs: defaultFiles
        });
    }

    removeFile (id, fileId) {
        return this.delete({
            url: `${this.basePath}/suppliers/${id}/files/${fileId}`,
        });
    }

    normalize (supplier) {
        if (_.isNil(supplier)) {
            return supplier;
        }

        const user = supplier.user;

        // Prepare person
        usersService.normalize(user);

        return supplier;
    }

    normalizeAllTransfers (transfers) {
        return _.map(transfers, transfer => {
            transfersService.normalize(transfer);
            usersService.normalize(transfer.users.origin);

            return transfer;
        });
    }
}

export default new Suppliers();
